import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage';

const getValue = (merchantId, key, moduleId) => {
	return Client.get(`${baseUrl}/merchant-setting/${merchantId}`, {
		key,
		moduleId,
	});
};

const getValues = (merchantId, moduleId) => {
	return Client.get(
		`${baseUrl}/merchant-setting/${merchantId}/list/${moduleId}`
	);
};

const setValue = (merchantId, payload) => {
	return Client.post(`${baseUrl}/merchant-setting/${merchantId}`, payload);
};

export default {
	getValue,
	getValues,
	setValue,
};
